// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outcome-automation-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
  border: 1px solid #D5D7DA;
  border-radius: 8px;
  padding: 12px 16px 16px;
  box-sizing: border-box;
}
.outcome-automation-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
}
.outcome-automation-card__title {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  color: #181D27;
}
.outcome-automation-card__title svg {
  font-size: 18px;
}
.outcome-automation-card__outcome-icon {
  flex-shrink: 0;
  color: #414651;
  font-size: 24px;
  line-height: 1;
}
.outcome-automation-card__name {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #181D27;
}
.outcome-automation-card__meta {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #414651;
}
.outcome-automation-card__controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 12px;
  row-gap: 12px;
  min-width: 0;
}
.outcome-automation-card__chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
/*# sourceMappingURL=OutcomeAutomationCard.css.map */`, "",{"version":3,"sources":["webpack://./OutcomeAutomationCard.less","webpack://./wp_components/Automations/components/OutcomeAutomationCard/OutcomeAutomationCard.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;ACDJ;ADGI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,YAAA;ACDR;ADII;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;ACFR;ADHI;EAOM,eAAA;ACDV;ADKI;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;ACHR;ADMI;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACJR;ADOI;EACI,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ACLR;ADQI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;ACNR;ADSI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;ACPR;AACA,oDAAoD","sourcesContent":["@import '../../../../less/variables.less';\n\n.outcome-automation-card {\n    display: flex;\n    flex-direction: column;\n    gap: @padding-xl;\n    background: @white;\n    border: 1px solid @secondary-300;\n    border-radius: @radius-md;\n    padding: @padding-lg @padding-xl @padding-xl;\n    box-sizing: border-box;\n\n    &__header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: @padding-md;\n        min-width: 0;\n    }\n\n    &__title {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        min-width: 0;\n        color: @fg-primary;\n        svg{\n          font-size: 18px;\n        }\n    }\n\n    &__outcome-icon {\n        flex-shrink: 0;\n        color: @fg-secondary;\n        font-size: 24px;\n        line-height: 1;\n    }\n\n    &__name {\n        font-weight: @font-weight-normal;\n        font-size: 14px;\n        line-height: 20px;\n        color: @fg-primary;\n    }\n\n    &__meta {\n        display: inline-flex;\n        align-items: center;\n        flex-shrink: 0;\n        padding: 2px 6px;\n        border-radius: @radius-xs;\n        font-size: 14px;\n        line-height: 20px;\n        font-weight: @font-weight-normal;\n        color: @fg-secondary;\n    }\n\n    &__controls {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        column-gap: @padding-lg;\n        row-gap: @padding-lg;\n        min-width: 0;\n    }\n\n    &__chips {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        gap: @padding-lg;\n    }\n}\n",".outcome-automation-card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #ffffff;\n  border: 1px solid #D5D7DA;\n  border-radius: 8px;\n  padding: 12px 16px 16px;\n  box-sizing: border-box;\n}\n.outcome-automation-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-width: 0;\n}\n.outcome-automation-card__title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  color: #181D27;\n}\n.outcome-automation-card__title svg {\n  font-size: 18px;\n}\n.outcome-automation-card__outcome-icon {\n  flex-shrink: 0;\n  color: #414651;\n  font-size: 24px;\n  line-height: 1;\n}\n.outcome-automation-card__name {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #181D27;\n}\n.outcome-automation-card__meta {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n  color: #414651;\n}\n.outcome-automation-card__controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 12px;\n  row-gap: 12px;\n  min-width: 0;\n}\n.outcome-automation-card__chips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n/*# sourceMappingURL=OutcomeAutomationCard.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
